import { $api } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export function useProjectMembers(projectId: string) {
  const { backendToken } = useAuth();
  return $api.useQuery(
    "get",
    "/api/v1/projects/{project_id}/members",
    { params: { path: { project_id: projectId } } },
    { staleTime: 5 * 60 * 1000, enabled: !!projectId && !!backendToken },
  );
}
